var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { FctParam } from './FctParams';
var Output = /** @class */ (function () {
    function Output(params, chainId) {
        var _this = this;
        this.get = function () { return _this._params; };
        this.subscribe = function (_a) {
            var callback = _a.callback, id = _a.id;
            _this.observers.set(id, callback);
        };
        this.unsubscribe = function (_a) {
            var id = _a.id;
            _this.observers.delete(id);
        };
        this.updateSubscriptions = function () {
            var e_1, _a;
            try {
                for (var _b = __values(_this.observers), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var observer = _c.value;
                    observer[1](_this.params, undefined, _this.chainId);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        };
        this.observers = new Map();
        this._params = params;
        // this.paramsList.forEach((element) => {
        //   element.param.subscribe({ callback: this.updateSubscriptions, id: element.key })
        // })
        this.chainId = chainId;
    }
    Object.defineProperty(Output.prototype, "paramsList", {
        get: function () {
            var list = [];
            var setParamsList = function (outputParams, prevKey) {
                for (var key in outputParams) {
                    var name_1 = key;
                    var fctParam = outputParams[key];
                    var uniqueKey = (prevKey ? "".concat(prevKey, ".").concat(name_1) : name_1);
                    if (fctParam instanceof FctParam) {
                        list.push({ param: fctParam, key: uniqueKey });
                    }
                    else {
                        setParamsList(outputParams[key], uniqueKey ? uniqueKey : undefined);
                    }
                }
            };
            setParamsList(this.params);
            return list;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Output.prototype, "params", {
        get: function () {
            return this._params;
        },
        enumerable: false,
        configurable: true
    });
    Output.prototype.setOutputParams = function (params) {
        this.paramsList.forEach(function (_a, i) {
            var param = _a.param;
            if (typeof params[i] === 'boolean') {
                param.value = String(params[i]);
                param.updateSubsciptions();
                return;
            }
            param.value = params[i];
            param.updateSubsciptions();
        });
    };
    Output.prototype.set = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var setParams;
            return __generator(this, function (_a) {
                setParams = function (params, outputParams) {
                    for (var key in params) {
                        var fctParam = outputParams[key];
                        if (!fctParam)
                            continue;
                        if (fctParam instanceof FctParam) {
                            fctParam === null || fctParam === void 0 ? void 0 : fctParam.set({ value: params[key] });
                        }
                        else {
                            setParams(params[key], outputParams[key]);
                        }
                    }
                };
                setParams(params, this.params);
                return [2 /*return*/];
            });
        });
    };
    return Output;
}());
export { Output };
